import { Colors } from '@sigma-frontend-libs/commons'

import { sizes } from '@/utils'

import squircle from '@/components/icon/squircle'

export default function(h) {
  return h(
    squircle,
    {
      props: {
        tooltip: this.hint,
        icon: this.icon,
        color: Colors.grey,
        size: sizes.medium
      }
    }
  )
}
